import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_CORP_USER, IS_IOS_MOBILE, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';

const minTariffsWithAds: undefined | 'a' | 'b' = getFeature('min-tariffs-with-ads');
export const isMinTariffsWithAds = minTariffsWithAds === 'b' && !IS_CORP_USER;

const minTariffsWithAdsTouch: YearAndMonthProductIds = getFeature('min-tariffs-with-ads-touch');
const minTariffsWithAdsIOS: YearAndMonthProductIds = getFeature('min-tariffs-with-ads-ios');
const minTariffsWithAdsAndroid: YearAndMonthProductIds = getFeature('min-tariffs-with-ads-android');
const minTariffsWithAdsWebview: YearAndMonthProductIds = IS_IOS_MOBILE ? minTariffsWithAdsIOS : minTariffsWithAdsAndroid;
export const minTariffsWithAdsMobile: YearAndMonthProductIds = IS_WEBVIEW ? minTariffsWithAdsWebview : minTariffsWithAdsTouch;
